<template>
  <a-card
    title="Información de pago"
    bodyStyle="padding: 0px;"
    :bordered="false"
  >
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="Banco">
        {{ displayValue(paymentMethod?.bank ?? movement?.bank) }}
      </a-descriptions-item>
      <a-descriptions-item label="Tipo de pago">
        {{
          displayValue(
            paymentMethod?.paymentMethod ?? movement?.paymentMethod
          )
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Tipo de cuenta">
        {{ displayValue(paymentMethod?.accountType ?? movement?.accountType) }}
      </a-descriptions-item>
      <a-descriptions-item label="Número de cuenta">
        {{
          displayValue(
            paymentMethod?.accountNumber ?? movement?.accountNumber
          )
        }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script setup>
import { defineProps } from 'vue';

const displayValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

defineProps({
  paymentMethod: {
    type: Object,
    default: () => ({})
  },
  movement: {
    type: Object,
    default: () => ({})
  }
});
</script>
